// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CircleOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 32 32","focusable":"false"},"children":[{"tag":"circle","attrs":{"cx":"16","cy":"16","fill":"currentColor","r":"14","stroke-width":"2","stroke":"currentColor"}}]},"name":"circle","theme":"outlined"};

const CircleOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CircleOutlinedSvg} />;
  CircleOutlined.displayName = 'CircleOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CircleOutlined);
